export default "__VITE_ASSET__0b47ae13__"